// extracted by mini-css-extract-plugin
module.exports = {"multiFilters":"index__multiFilters___3gPYP","filter":"index__filter___18IH_ typography__bodyFont___1exgA","filterLabel":"index__filterLabel___2Aciu"};